import { useReactiveVar } from '@apollo/client';

import { useMemo } from 'react';

import { useMyCareerProfileQuery } from 'core';
import { authState } from 'core/state';
import { isCareerViewer } from 'core/hooks/CareerCenter/isCareerViewer';
import { ICareerProfileData, transformCareerProfile } from './transform';

// 🔴 Запрос уходит ТОЛЬКО зрителю карьерного раздела. Без этого условия
// преподаватель, открывший /growth по прямому адресу, получал пачку
// молчаливых PermissionDenied и полупустой экран: GraphQL-ошибки в клиенте
// не редиректят и не показывают тост, поэтому симптом выглядел как «раздел
// сломан», а в консоли лежала причина, которую никто не читает.
/**
 * Reads the student's career profile (spec 0018, increment B).
 *
 * `myCareerProfile` is created on first read and is open to ANY student
 * (self-only) — the section route stays reachable without a CareerMember.
 */
export const useCareerProfile = (): {
  profile: ICareerProfileData | null;
  loading: boolean;
  error?: string;
  refetch: () => void;
} => {
  const { active_role, isDemoUser } = useReactiveVar(authState);

  const { data, loading, error, refetch } = useMyCareerProfileQuery({
    fetchPolicy: 'cache-and-network',
    skip: !isCareerViewer(active_role) || Boolean(isDemoUser),
  });

  const profile = useMemo(() => transformCareerProfile(data), [data]);

  return { profile, loading, error: error?.message, refetch };
};
